// A course has no typed name: "Y{year level} {course type}", e.g. "Y7 Maths".
// In Term 4, Year 1-11 learn next year's work, so it shows as "Y7/8 Maths".
// The backend builds the same names (lms-backend helpers/courseName.js).
export const courseName = (grade, type, term) => {
  if (grade === undefined || grade === null || grade === "" || !type) return "";
  const g = Number(grade);
  const label = g === 0 ? "K" : `Y${g}`;
  const next = String(term) === "4" && g >= 1 && g <= 11 ? `/${g + 1}` : "";
  return `${label}${next} ${type}`;
};
